import { useCallback, useEffect, useState } from "react";

const isBrowser = typeof window !== "undefined";

export const usePersistentState = (key, initialValue) => {
  const [state, setState] = useState(() => {
    if (!isBrowser) return initialValue;
    try {
      const raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    if (!isBrowser) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(state));
    } catch {
      // ignore storage write failures (e.g. quota exceeded)
    }
  }, [key, state]);

  const clearStored = useCallback(() => {
    if (!isBrowser) return;
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      // ignore storage remove failures
    }
  }, [key]);

  return [state, setState, clearStored];
};
